import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { format, isValid } from "date-fns";
import { es } from "date-fns/locale";

import {
  addMonths,
  startOfMonth,
  subMonths,
  endOfMonth,
  endOfDay,
  startOfDay,
} from "date-fns";
import {
  Box,
  Button,
  ButtonGroup,
  Grid,
  TextField,
  Typography,
  FormControl,
  Select,
  Checkbox,
  ListItemText,
  MenuItem,
  Input,
  OutlinedInput,
  Menu,
  FormControlLabel,
  makeStyles,
} from "@material-ui/core";
import { Save as SaveIcon } from "@material-ui/icons";
import { DatePicker } from "@material-ui/pickers";
import formats from "../../../../resources/formats.json";
import zones from "../../../../resources/zones.json";
import useMenu from "../../../../hooks/useMenu";
import indicatorsActions from "../../../../redux/actions/indicators";
import getDateFormated from "../../../../helpers/FormatHours";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "80%",
    },
  },
}));

export default function Content() {
  const classes = useStyles();
  const [date, setDate] = useState({
    type: "CURRENT",
    initialDate: null,
    endDate: null,
    isCustom: false
  });
  const dispatch = useDispatch();
  const { exportFilters } = useSelector((state) => state.indicators);
  const app = useSelector((state) => state.app);

  const { open, anchorEl, handleOpen, handleClose } = useMenu();
  const [fileName, setFileName] = useState("Reporte de metas");
  const [greenPoints, setGreenPoints] = useState([]);
  const [onlyNewMaterials, setOnlyNewMaterials] = useState(false);

  const handleChangeZones = (event) => {
    dispatch(
      indicatorsActions.updateExportFilters({
        ...exportFilters,
        zones: event.target.value,
      })
    );
  };

  const handleChangeFormats = (event) => {
    dispatch(
      indicatorsActions.updateExportFilters({
        ...exportFilters,
        formats: event.target.value,
      })
    );
  };
  const getCheckedGreenPoints = (list) => {
    return list.filter((item) => item.checked).map((item) => item._id);
  };

  const checkGreenPoint = (id) => {
    const newGreenPoints = greenPoints.map((item) => {
      return item._id !== id ? item : { ...item, checked: !item.checked };
    });
    setGreenPoints(newGreenPoints);
  };
  const checkAllGreenPoints = () => {
    const allSelected =
      greenPoints.filter((item) => !item.checked).length === 0;

    const newGreenPoints = greenPoints.map((item) => ({
      ...item,
      checked: !allSelected,
    }));
    setGreenPoints(newGreenPoints);
  };

  const onGenerateFile = () => {
    const init = new Date(date.initialDate)
    const end = new Date(date.endDate)
    const delay = new Date().getTimezoneOffset() / 60;
    init.setHours(init.getHours() + delay);
    end.setHours(end.getHours() + delay);
    end.setDate(end.getDate() - 1);
    const initStr = `${init.getFullYear()}${(init.getMonth() + 1).toString().padStart(2, "0")}${init.getDate().toString().padStart(2, "0")}`
    const endStr = `${end.getFullYear()}${(end.getMonth() + 1).toString().padStart(2, "0")}${end.getDate().toString().padStart(2, "0")}`
    const fileNameComplete = `${fileName}-${initStr}-${endStr}`
    dispatch(
      indicatorsActions.getExcelFile(
        fileNameComplete,
        exportFilters.zones,
        exportFilters.formats,
        getDateFormated(date.initialDate),
        getDateFormated(date.endDate),
        getCheckedGreenPoints(greenPoints),
        onlyNewMaterials,
        date.isCustom
      )
    );
  };

  useEffect(() => {
    let initialDate = null;
    let endDate = null;
    let isCustom = false;
    switch (date.type) {
      case "PREVIOUS":
        endDate = startOfMonth(new Date());
        initialDate = subMonths(endDate, 1);
        break;
      case "RANGE":
        initialDate = startOfMonth(new Date());
        endDate = endOfMonth(initialDate);
        isCustom = true;
        break;
      default:
        initialDate = startOfMonth(new Date());
        endDate = endOfMonth(initialDate);
        break;
    }
    setDate({ ...date, initialDate, endDate, isCustom });
  }, [date.type]);

  useEffect(() => {
    const initialDate = startOfMonth(new Date());
    const endDate = addMonths(initialDate, 1);
    setDate({ ...date, initialDate, endDate });
    dispatch(
      indicatorsActions.updateExportFilters({
        ...exportFilters,
        formats: formats.map((item) => item.code),
        zones: zones.map((item) => item.code),
      })
    );
  }, []);

  useEffect(() => {
    setGreenPoints(
      exportFilters.greenPointList.map((item) => ({ ...item, checked: true }))
    );
  }, [exportFilters.greenPointList]);

  return (
    <Box minWidth="500px" p={2}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Archivo</Typography>
          <TextField
            variant="outlined"
            fullWidth
            margin="dense"
            label="Nombre del archivo"
            value={fileName}
            onChange={(e) => setFileName(e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <Box>
            <Typography variant="h6">Fecha</Typography>
          </Box>
          <Box paddingTop="10px">
            <ButtonGroup size="small" variant="contained">
              <Button
                color={date.type === "CURRENT" ? "primary" : "secondary"}
                onClick={() => setDate({ ...date, type: "CURRENT" })}
                variant="contained"
                size="small"
              >
                Mes actual
              </Button>
              <Button
                color={date.type === "PREVIOUS" ? "primary" : "secondary"}
                onClick={() => setDate({ ...date, type: "PREVIOUS" })}
                variant="contained"
                size="small"
              >
                Mes anterior
              </Button>
              <Button
                color={date.type === "RANGE" ? "primary" : "secondary"}
                onClick={() => setDate({ ...date, type: "RANGE" })}
                variant="contained"
                size="small"
              >
                Seleccionar rango
              </Button>
            </ButtonGroup>
          </Box>
          {date.type === "RANGE" && (
            <Box paddingTop="10px">
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <DatePicker
                    inputVariant="outlined"
                    margin="dense"
                    fullWidth
                    label="Mes"
                    views={["year", "month"]}
                    openTo="month"
                    value={date.initialDate}
                    labelFunc={(value, invalidLabel) => {
                      if (!value) return invalidLabel;
                      const jsDate = new Date(value);
                      if (!isValid(jsDate)) return invalidLabel;
                      const formatted = format(jsDate, "MMMM yyyy", { locale: es });
                      return formatted.charAt(0).toUpperCase() + formatted.slice(1);
                    }}
                    onChange={(d) => {
                      const selectedMonth = startOfMonth(new Date(d));
                      setDate({
                        ...date,
                        initialDate: selectedMonth,
                        endDate: endOfMonth(selectedMonth),
                      });
                    }}
                    disableFuture
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography variant="h6">Formato</Typography>
            <FormControl style={{ width: "100%" }}>
              <Select
                labelId="formats-checkbox-label"
                id="formats-mutiple-checkbox"
                multiple
                value={exportFilters.formats}
                onChange={handleChangeFormats}
                input={<OutlinedInput margin="dense" />}
                renderValue={(selected) => `${selected.length} seleccionados`}
                MenuProps={{
                  PaperProps: {
                    style: {
                      minWidth: 250,
                      textAlign: "right",
                    },
                  },
                }}
              >
                {formats.map((format) => (
                  <MenuItem key={format.code} value={format.code}>
                    <Checkbox
                      checked={exportFilters.formats.indexOf(format.code) > -1}
                    />
                    <ListItemText primary={format.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography variant="h6">Zona</Typography>
            <FormControl style={{ width: "100%" }}>
              <Select
                labelId="zone-checkbox-label"
                id="zone-mutiple-checkbox"
                multiple
                value={exportFilters.zones}
                onChange={handleChangeZones}
                input={<OutlinedInput margin="dense" />}
                renderValue={(selected) => `${selected.length} seleccionados`}
                MenuProps={{
                  PaperProps: {
                    style: {
                      minWidth: 250,
                    },
                  },
                }}
              >
                {zones.map((zone) => (
                  <MenuItem key={zone.code} value={zone.code}>
                    <Checkbox
                      checked={exportFilters.zones.indexOf(zone.code) > -1}
                    />
                    <ListItemText primary={zone.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography variant="h6">Puntos Gira</Typography>
            <TextField
              label={`${greenPoints.length} Puntos Gira encontrados`}
              variant="outlined"
              fullWidth
              margin="dense"
              onClick={handleOpen}
              value={`${
                greenPoints.filter((item) => item.checked).length
              } seleccionados`}
            ></TextField>

            <Menu
              open={open}
              anchorEl={anchorEl}
              keepMounted
              onClose={handleClose}
              classes={{ paper: classes.paper }}
            >
              <Box p={2}>
                <Box padding="5px 10px">
                  <Typography style={{ fontWeight: "bold" }}>
                    PUNTOS GIRA
                  </Typography>
                </Box>
                <Grid container spacing={1}>
                  <Grid item xs={6} md={4}>
                    <MenuItem>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              greenPoints.filter((item) => !item.checked)
                                .length === 0
                            }
                            color="primary"
                            onChange={checkAllGreenPoints}
                          />
                        }
                        label={"Todos"}
                      />
                    </MenuItem>
                  </Grid>
                  {greenPoints.map((greenPoint) => (
                    <Grid item xs={6} md={4} key={greenPoint._id}>
                      <MenuItem>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={greenPoint.checked}
                              color="primary"
                              onChange={() => checkGreenPoint(greenPoint._id)}
                            />
                          }
                          label={greenPoint.name}
                        />
                      </MenuItem>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Menu>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <hr />
          <Box display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={onGenerateFile}
              startIcon={<SaveIcon />}
              disabled={app.loading}
            >
              Descargar archivo
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
